import { useContext } from 'react';

import { ContextGeniusDetail } from '@/context/GeniusDetail';
import type { MindDetail } from '@/types/mindDetail';

export default function useGenius(): MindDetail {
  return useContext(ContextGeniusDetail);
}
